import script from "./FormSetting.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSetting.vue?vue&type=script&setup=true&lang=js"

import "./FormSetting.vue?vue&type=style&index=0&id=37c80868&lang=scss"

const __exports__ = script;

export default __exports__